import React from 'react';
import MasterCategoriesDataTable from 'components/categories/merchandisingcategories/MerchandisingCategoriesDataTable';

const MasterCategoriesPage = () => {
  return <MasterCategoriesDataTable />;
};

export default MasterCategoriesPage;
